import request from '@/utils/request'

export function enterpriseShow(id) {
    return request({
        url: `/api/enterprise/home/showBy/${id}`,
        method: 'get'
    })
}


/**
 * 加工厂首页
 * @param data
 * @returns {*}
 */
export function homePlantPage(data) {
    return request({
        url: '/api/enterprise/home/plantPage',
        method: 'post',
        data
    })
}

/**
 * 供应商首页
 * @param data
 * @returns {*}
 */
export function homeSupplierPage(data) {
    return request({
        url: '/api/enterprise/home/supplierPage',
        method: 'post',
        data
    })
}

/**
 * 企业详情
 * @param id
 * @returns {*}
 */
export function enterpriseById(id) {
    return request({
        url: `/api/enterprise/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 加工厂产品分页
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function productPlantPage(data) {
    return request({
        url: `/api/company/product/home/plantPage`,
        method: 'post',
        data
    })
}

/**
 * 供应商产品分页
 * @param data
 * @returns {*}
 */
export function productSupplierPage(data) {
    return request({
        url: `/api/company/product/home/supplierPage`,
        method: 'post',
        data
    })
}

/**
 * 产品详情
 * @param id
 * @returns {*}
 */
export function productById(id) {
    return request({
        url: `/api/company/product/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 产品推荐
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function productSupplierRecommend() {
    return request({
        url: `/api/company/product/home/supplierRecommend`,
        method: 'get'
    })
}

/**
 * 产品推荐
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function productPlantRecommend() {
    return request({
        url: `/api/company/product/home/plantRecommend`,
        method: 'get'
    })
}

/**
 * 询盘分页
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function inquiryPage(data) {
    return request({
        url: `/api/inquiry/home/page`,
        method: 'post',
        data
    })
}

/**
 * 询盘详情
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function inquiryById(id) {
    return request({
        url: `/api/inquiry/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 根据询盘查询零件信息
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function inquiryPart(id) {
    return request({
        url: `/api/inquiry/home/partBy/${id}`,
        method: 'get'
    })
}

/**
 * 询盘推荐
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function inquiryRecommend() {
    return request({
        url: `/api/inquiry/home/recommend`,
        method: 'get'
    })
}

/**
 * 加工厂询价分页
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function plantEnquiryPage(data) {
    return request({
        url: `/api/enquiry/home/plant/page`,
        method: 'post',
        data
    })
}

/**
 * 供应商询价分页
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function supplierEnquiryPage(data) {
    return request({
        url: `/api/enquiry/home/supplier/page`,
        method: 'post',
        data
    })
}

/**
 * 询盘详情
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function enquiryById(id) {
    return request({
        url: `/api/enquiry/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 询盘推荐
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function enquirySupplierRecommend() {//仪器设备询价
    return request({
        url: `/api/enquiry/home/supplier/recommend`,
        method: 'get'
    })
}
export function enquiryFactoryRecommend() {//铸件机加工询价
    return request({
        url: `/api/enquiry/home/plant/recommend`,
        method: 'get'
    })
}

/**
 * 生产工艺
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function techniqueById(id) {
    return request({
        // url: `/api/company/technique/home/techniqueBy/${id}`,
        url:`/api/enterprise/production/home/${id}`,
        method: 'get'
    })
}
export function techniqueLabelList(id) {//工艺标签列表
    return request({
        // url: `/api/company/technique/home/techniqueBy/${id}`,
        url:`/api/enterprise/technique/home/${id}/label`,
        method: 'get'
    })
}

// 供应信息
export function supplierInfo(id) {//供应信息
    return request({
        url:`/api/enterprise/supply/home/${id}`,
        method: 'get'
    })
}
//采购商信息
export function buyerInfo(id) {//采购商信息
    return request({
        url:`/api/enterprise/purchase/home/${id}`,
        method: 'get'
    })
}


/**
 * 生产设备
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function productionEquipment(id) {
    return request({
        // url: `/api/company/equipment/productionBy/${id}`,
        url: `/api/company/equipment/home/productionBy/${id}`, //允许公开访问
        method: 'get'
    })
}

/**
 * 检测设备
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function checkoutEquipment(id) {
    return request({
        // url: `/api/company/equipment/checkoutBy/${id}`,
        url: `/api/company/equipment/home/checkoutBy/${id}`,//允许公开访问
        method: 'get'
    })
}

/**
 * 典型产品
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function modelProduct(id) {
    return request({
        url: `/api/company/product/home/modelBy/${id}`,
        method: 'get'
    })
}

/**
 *  客户
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function customers(id) {
    return request({
        url: `/api/company/customers/home/byId/${id}`,
        method: 'get'
    })
}

/**
 * 资质
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function qualifications(id) {
    return request({
        // url: `/api/company/qualification/home/byId/${id}`,
        url:`/api/company/qualification/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 营业执照
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function businessLicense(id) {
    return request({
        // url: `/api/enterprise/businessLicense/getBy/${id}`,
        url: `/api/enterprise/home/businessLicense/getBy/${id}`,//允许公开访问
        method: 'get'
    })
}

/**
 * 联系方式
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function contentWay(id) {
    return request({
        // url: `/api/enterprise/contentWay/by/${id}`,
        url: `/api/enterprise/home/contentWay/by/${id}`,//允许公开访问
        method: 'get'
    })
}

/**
 * 概况
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function overview(id) {
    return request({
        url: `/api/enterprise/home/overview/by/${id}`,
        method: 'get'
    })
}

/**
 * 生产工艺
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function techniqueHome(data) {
    return request({
        url: `/api/company/technique/home/by/ids`,
        method: 'post',
        data
    })
}

/**
 * 获取工艺左侧树
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function techniqueList(id) {
    return request({
        url: `/api/company/technique/home/listBy/${id}`,
        method: 'get'
    })
}

/**
 * 生产设备
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function productionHomePage(data) {
    return request({
        url: `/api/company/equipment/home/productionPageById`,
        method: 'post',
        data
    })
}

/**
 * 检测设备
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function checkoutHomePage(data) {
    return request({
        url: `/api/company/equipment/home/checkoutPageById`,
        method: 'post',
        data
    })
}

/**
 * 典型产品
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function modelProductHomePage(data) {
    return request({
        url: `/api/company/product/home/modelPage`,
        method: 'post',
        data
    })
}

/**
 * 客户
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function customerHomePage(data) {
    return request({
        url: `/api/company/customers/home/page`,
        method: 'post',
        data
    })
}

/**
 * 资质
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function qualificationHomePage(data) {
    return request({
        url: `/api/company/qualification/home/page`,
        method: 'post',
        data
    })
}

/**
 * 相册
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function albumHome(id) {
    return request({
        url: `/api/company/album/home/by/${id}`,
        method: 'get'
    })
}

/**
 * 视频
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function videoHome(id) {
    return request({
        url: `/api/company/video/home/by/${id}`,
        method: 'get'
    })
}
/**
 * 会员充值
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function memberHomeInfo() {
    return request({
        url: `/member/info/home/info`,
        method: 'get'
    })
}

// 生产与工艺
export function productionAndTechnique(id) {//生产与工艺
    return request({
        url: `/api/enterprise/technique/home/${id}/overview`,
        method: 'get'
    })
}
